<template>
  <td>
    <slot />
  </td>
</template>

<style lang="postcss" scoped>
tbody td {
  padding: 0.5em;
  vertical-align: top;
}

tbody td:first-child {
  padding-left: 0;
}

tbody td:last-child {
  padding-right: 0;
}

.table-border tbody td {
  border: 1px solid var(--color-gray-300);
  padding: calc(var(--spacing) * 2);
}
</style>
